import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { IMAGES, PHONE, PHONE_LINK } from "@/data/site";
import { Accent, Reveal } from "@/components/Reveal";

const CtaBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section ref={ref} data-testid="cta-banner" className="relative overflow-hidden">
      <motion.img
        src={IMAGES.cta}
        alt="Canoes on a mountain lake at golden hour"
        loading="lazy"
        style={{ y: bgY }}
        className="absolute inset-0 w-full h-[128%] object-cover -mt-[8%]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F14]/95 via-[#0B0F14]/75 to-[#1E6FB8]/45" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-28 sm:py-36">
        <Reveal>
          <p className="eyebrow">The Road Is Waiting</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-sora text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] mt-5 max-w-3xl">
            Ready for your next <Accent>journey?</Accent>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="text-base text-[#F5F5F0]/70 max-w-xl mt-6 leading-relaxed">
            One call. One form. A trip built entirely around you — with a driver you can trust
            and a team that never sleeps.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="flex flex-wrap items-center gap-4 mt-10">
            <Link to="/contact" data-testid="cta-book-now" className="btn-gold">
              Book Now <ArrowRight size={16} />
            </Link>
            <a href={PHONE_LINK} data-testid="cta-phone" className="btn-outline">
              <Phone size={16} className="text-[#3FB6D3]" /> {PHONE}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
